export default [
  {
    sn: '01',
    title: 'Leadership School',
    subTitle: 'Purple Academy',
    summary: 'Purple Leadership School is at the pinnacle of our Corporate University that seeks to fuel our current leadership, build resilience, drive succession with a high-performance pipeline and groom the next generation of leaders to thrive and excel in business in an ever-changing world.',
    link: 'https://www.youtube.com/watch?v=TIj6pHdnnaM',
    video_id: 'TIj6pHdnnaM'
  }
];
